import SessionQrDisplayPageActionTypes from '../actions/session-qr-display-page-action-types';

const initialState = {
  loading: false,
  qr: null,
  disabled: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SessionQrDisplayPageActionTypes.LOAD_SESSION_QR_DISPLAY_START:
      return {
        ...state,
        loading: true
      };
    case SessionQrDisplayPageActionTypes.LOAD_SESSION_QR_DISPLAY_END:
      return {
        ...state,
        loading: false,
        qr: action.payload?.qr
      };
    case SessionQrDisplayPageActionTypes.SET_SESSION_QR_DISPLAY_DISABLED:
      return {
        ...state,
        disabled: action.payload.disabled
      };
    default:
      return state;
  }
};
